import { Component, inject } from '@angular/core'

import { CalendlyService } from '../../modules/shared/services/calendly.service'

@Component({
  standalone: false,
  templateUrl: './trial-gate.component.html',
  styleUrls: ['./trial-gate.component.scss'],
})
export class TrialGateComponent {
  private calendlyService = inject(CalendlyService)

  public talkToCyborg(): void {
    this.calendlyService.talkToCyborg()
  }
}
